import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { Role } from '@app-models/role.model';
import { HttpService } from '@app-providers/http.service';

@Injectable({
  providedIn: 'root',
})
export class RoleService extends BaseService<Role> {
  constructor(protected _httpService: HttpService) {
    super(_httpService, Role, 'role');
  }
}
